import { ENDPOINT } from "./FormData";

export class UnsubscribeData {
    static instance: UnsubscribeData = new UnsubscribeData()

    /**
     * Checks if a user is registered with the given email address.
     * 
     * @param emailAddress - The user's email address to check
     * @param ifRegistered - Callback to call if the user is registered
     * @param ifNotRegistered - Callback to call if the user is not registered     
     */
    isUserRegistered(
        emailAddress: string,
        ifRegistered: (data: any) => void,
        ifNotRegistered: () => void
    ): void {

        const queryParams = new URLSearchParams({
            email: emailAddress,
            cell: "+11111111111" // Placeholder, not used in this context
        });

        const url = `${ENDPOINT}/isalreadyregistered?${queryParams.toString()}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                // Call the provided callback with the parsed JSON content
                if (data.email_registered) {
                    ifRegistered(data);
                } else {
                    ifNotRegistered();
                }

            })
            .catch(err => {
                console.log(err)
            })
    }

    /**
     * Sends an email to the user with a link to unsubscribe.
     * 
     * @param emailAddress - The user's email address
     * @param patientID - The patient's ID
     * @param autoUnsubParam - Optional parameter for automatic unsubscription
     * @param whenSuccess - Callback to call when the email is sent successfully
     * @param whenFailed - Callback to call when the email sending fails
     */
    sendUnsubscribeEmail(
        emailAddress: string,
        patientID: string,
        autoUnsubParam: string,
        whenSuccess: (data: any) => void,
        whenFailed: () => void
    ): void {
        const queryParams = new URLSearchParams({
            email: emailAddress,
            patientID: patientID
        });

        if (autoUnsubParam === "True") {
            queryParams.append('auto_unsub', 'True');
        }

        const url = `${ENDPOINT}/sendunsubscribeurl?${queryParams.toString()}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.ok) {
                    return response.text()
                } else {
                    whenFailed()
                }
            })
            .then(data => {
                console.log(data);
                whenSuccess(data);
            })
            .catch(err => {
                console.log(err);
                whenFailed();
            })
    }
}